import { invokeApi, VENDOR_API_BASE_URL } from "../../../helper/axiosHelper";

export const exportVendorMembers = async (filters) => {
    const response = await invokeApi(
        "post",
        "/vendorMemberExport",
        filters,
        {},
        "vendor"
    );

    if (!response?.status) {
        return { status: false, message: response?.message || "Export failed" };
    }

    const url = `${VENDOR_API_BASE_URL}/${String(response.data?.filePath || "")
        .split("/")
        .map(encodeURIComponent)
        .join("/")}`;

    try {
        const file = await fetch(url);
        if (!file.ok) throw new Error(String(file.status));
        const blob = await file.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = window.document.createElement("a");
        link.href = objectUrl;
        link.download = "members.xlsx";
        window.document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
        window.open(url, "_blank", "noopener");
    }

    return { status: true };
};
